/**
 * ID处理工具函数
 * 用于统一处理bigint类型的ID，避免JavaScript Number类型精度丢失
 */

// ID字段列表（需要转换为字符串的字段）
const ID_FIELDS = [
  'id',
  'comicId',
  'orderId',
  'paymentId',
  'outTradeNo',
  'interactionMessageId',
  'messageId',
  'userId',
  'authorId',
  'targetId',
  'belongId',
  'parentId',
  'feedbackId',
  'volNum' // 卷号也可能需要处理
]

/**
 * 递归转换对象中的ID字段为字符串
 * @param {any} obj - 要处理的对象
 * @param {boolean} deep - 是否深度遍历
 * @returns {any} - 处理后的对象
 */
export function convertIdsToString(obj, deep = true) {
  if (obj === null || obj === undefined) {
    return obj
  }

  // 如果是数组，递归处理每个元素
  if (Array.isArray(obj)) {
    return obj.map(item => convertIdsToString(item, deep))
  }

  // 如果是对象，处理每个属性
  if (typeof obj === 'object') {
    const result = {}
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key]

        // 如果是ID字段
        if (ID_FIELDS.includes(key)) {
          // 如果是 null 或 undefined，保留原值（不跳过）
          if (value === null || value === undefined) {
            result[key] = value
          }
          // 如果是数字类型，转换为字符串
          else if (typeof value === 'number') {
            result[key] = String(value)
          }
          // 如果已经是字符串，保持不变
          else if (typeof value === 'string') {
            result[key] = value
          }
          // 其他类型也转换为字符串
          else {
            result[key] = String(value)
          }
        } else if (deep && (typeof value === 'object' || Array.isArray(value))) {
          // 深度遍历对象和数组
          result[key] = convertIdsToString(value, deep)
        } else {
          result[key] = value
        }
      }
    }
    return result
  }

  return obj
}

/**
 * 转换单个ID值为字符串
 * @param {any} id - ID值
 * @returns {string} - 字符串类型的ID
 */
export function toIdString(id) {
  if (id === null || id === undefined) {
    return id
  }
  return String(id)
}

/**
 * 处理路由参数中的ID字段，转换为字符串
 * 用于路由跳转时统一处理ID参数
 * @param {object} params - 路由参数对象
 * @returns {object} - 处理后的参数对象
 */
export function convertRouteParams(params) {
  if (!params || typeof params !== 'object') {
    return params
  }

  const result = { ...params }

  // 转换常见的ID字段
  ID_FIELDS.forEach(field => {
    if (result[field] !== undefined && result[field] !== null) {
      result[field] = String(result[field])
    }
  })

  return result
}

